import { modulesResolver } from "@resolvers/modules.resolver";

import { type Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    loadComponent: () => import("./modules/login/login.component"),
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./modules/reset-password/reset-password.component"),
  },
  {
    path: "dashboard/:tenantId",
    loadComponent: () => import("./modules/dashboard/dashboard.component"),
    resolve: { modules: modulesResolver },
    loadChildren: () => import("./modules/dashboard/dashboard.routes"),
  },
  {
    path: "qrs/:tenantId/:section",
    loadComponent: () => import("./modules/qrs/qrs.component"),
  },
  {
    path: "landing-zone",
    loadComponent: () =>
      import("./modules/landing-zone/landing-zone.component"),
  },
  {
    path: "wsp-readings",
    loadComponent: () =>
      import("./modules/wsp-readings/wsp-readings.component"),
  },
  {
    path: "wsp-pressure-sensor",
    loadComponent: () =>
      import("./modules/wsp-pressure-sensor/wsp-pressure-sensor.component").then(
        m => m.WspPressureSensorComponent
      ),
  },
  {
    path: "wsp-estanque",
    loadComponent: () =>
      import("./modules/wsp-estanque/wsp-estanque.component").then(
        m => m.WspEstanqueComponent
      ),
  },
  {
    path: "pagos",
    loadComponent: () =>
      import("./modules/payments/payments-page/payments-page.component"),
  },
  {
    path: "no-access",
    loadComponent: () =>
      import("./modules/no-access/no-access.component").then(
        m => m.NoAccessComponent
      ),
  },
  {
    path: "**",
    loadComponent: () =>
      import("./modules/not-found/not-found.component").then(
        m => m.NotFoundComponent
      ),
  },
];
